import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardHeader } from "reactstrap";

export function SLCardSelectable({
  selected = false,
  title = "",
  name,
  value,
  cardBody,
  className = "",
  onChange = (e) => {},
}) {
  return (
    <div className={`cursor-pointer ${className}`} onClick={() => onChange({ target: { name, value } })}>
      <Card
        className={
          "mb-0 pb-0 card-selectable-card  justify-content-center" +
          (selected === true
            ? " card-selectable-card-selected"
            : " card-selectable-card-non-selected")
        }
      >
        <CardHeader
        className={
          " justify-content-center card-selectable-header" +
          (selected === true
            ? " card-selectable-header-selected"
            : " card-selectable-header-non-selected")
        }>{title}</CardHeader>
        {cardBody && (
          <CardBody className={"p-3 mb-0 w-100 h-100"}>{cardBody}</CardBody>
        )}
      </Card>
    </div>
  );
}
// SLCardSelectable.propTypes = {
//   selected: PropTypes.bool,
//   onClick: PropTypes.func,
// };



// WEBPACK FOOTER //
// ./src/components/editors/SLCardSelectable.jsx